export const validationLimitingValue = {
    /** TODO 값이 없어서 임시로 추가함. 나중에 확인 후 입력 필요함 tg0825 20240120 */
    MEMO_MAX_LENGTH: 10_000,
    /** 대행료 설정 가능 최대 금액 */
    ADJUST_DELIVERY_MAXIMUM_AMOUNT: 200_000,
    /** 라이더 지원금 최대 금액 */
    WORKER_SUPPORT_MAXIMUM_AMOUNT: 10_000,
    /** 출금 수수료 금액 */
    REQUEST_WITHDRAW_COMMISSION_AMOUNT: 2000,
    /** 출금 최대 금액 */
    REQUEST_WITHDRAW_MAXIMUM_AMOUNT: 10_000_000,
    /** 출금 최소 금액 */
    REQUEST_WITHDRAW_MINIMUM_AMOUNT: 2000,
    /** 바로머니 송금 최대 금액 */
    REMITTANCE_BAROMONEY_MAXIMUM_AMOUNT: 100_000,
    /** 허브 운행설정 추가할증 최대 정액 (리뉴얼 이후 미사용) */
    ADD_DELIVERY_CHARGE_MAXIMUM_AMOUNT: 10_000,
    /** 허브 운행설정 추가할증 최대 정액 길이 */
    ADD_DELIVERY_CHARGE_MAXIMUM_LENGTH: 5,
    /** 허브 운행설정 추가할증 최대 정률 */
    ADD_DELIVERY_CHARGE_RATE_MAXIMUM_RATE: 100,
    /** 허브 운행설정 추가할증 최대 정률 길이 */
    ADD_DELIVERY_CHARGE_RATE_MAXIMUM_LENGTH: 2,
    /** 라이더 관리 예치금/배차 제한잔액 최대 금액 */
    BAROMONEY_MAX_AMOUNT: 9_999_999,
    /** 라이더 관리 배차 제한잔액 최대 길이 */
    BAROMONEY_MAX_LENGTH: 8,
    /**
     * 입력값 최대 바이트
     * 관련 노션: https://www.notion.so/barogohq/Client-API-Size-check-07ae9bb1de044eaf9791ebb514908469?pvs=4
     */
    /** 라이더관리 > 라이더명 최대 바이트 */
    WORKER_NAME_MAX_BYTE: 28,
    /** 라이더 관리 > 사번 최대 바이트 */
    HUB_EMPLOYEE_NUMBER_MAX_BYTE: 10,
    /** 단말기/전화/휴대폰/대표자 휴대폰 번호 최대 길이 */
    PHONE_MIN_LENGTH: 9,
    /** 단말기/전화/휴대폰/대표자 휴대폰 번호 최대 길이 */
    PHONE_MAX_LENGTH: 15,
    /** 라이더 관리 주소 최대 길이 */
    ADDRESS_MAX_LENGTH: 100,
    /** 상점 관리 > 주소 최대 byte */
    STORE_ADDRESS_DETAIL_MAX_BYTE: 200,
    /** 상세주소 최대 byte */
    ADDRESS_DETAIL_MAX_BYTE: 80,
    /** 라이더 관리 관리자 메모 최대 길이 */
    WORKER_CREATE_MEMO_MAX_LENGTH: 200,
    /** 라이더 관리 , 상점관리 예치금 최대 길이 */
    DEPOSIT_BAROMONEY_MAX_LENGTH: 8,
    /** 라이더 관리 출금계좌 계좌번호 최대 길이 */
    WITHDRAWAL_BANK_ACCOUNT_MAX_LENGTH: 14,
    /** 라이더 관리 출금계좌 예금주 최대 길이 */
    WITHDRAWAL_BANK_OWNER_MAX_LENGTH: 15,
    /** 라이더 관리 주민등록번호 제한 길이(hypen 포함) */
    HYPEN_SOCIAL_NUMBER_LIMIT_LENGTH: 14,
    /** 라이더 관리 주민등록번호 제한 길이(hypen 미포함) */
    NO_HYPEN_SOCIAL_NUMBER_LIMIT_LENGTH: 13,
    /** 라이더 관리 면허번호 제한 길이(hypen 미포함) */
    LICENSE_NUMBER_MIN_LENGTH: 12,
    /** 라이더 관리 면허번호 제한 길이(hypen 포함) */
    LICENSE_NUMBER_MAX_LENGTH: 15,
    /** 라이더 관리 라이더 수수료 그룹 명 최대 길이 */
    WORKER_FEE_GROUP_NAME_MAX_LENGTH: 50,
    /** 일일 미 차감 건수 최대 길이(comma 포함 10억 미만) */
    DAY_FEE_COUNT_MAX_LENGTH: 12,
    /** 라이더 관리 차량번호 최대 길이 */
    CAR_NUMBER_MAX_LENGTH: 9,
    /** TODO 자동차감그룹 관련 enum들은 임의 값 넣어둠, 기획팀 확인 필요 */
    /** 라이더 관리 자동차감그룹 그룹명 최대 길이 */
    CASH_AUTO_DEDUCT_GROUP_NAME_MAX_LENGTH: 50,
    /** 라이더 관리 자동차감그룹 스케줄명 최대 길이 */
    CASH_AUTO_DEDUCT_GROUP_SCHEDULE_NAME_MAX_LENGTH: 50,
    /** 라이더 관리 자동차감그룹 금액 최대 길이 */
    CASH_AUTO_DEDUCT_AMOUNT_MAX_LENGTH: 9,
    /** 라이더 관리 자동차감그룹 관리자 메모 최대 길이 */
    CASH_AUTO_DEDUCT_GROUP_SCHEDULE_MEMO_MAX_LENGTH: 200,
    /** 라이더 관리 배차 후 완료가능 최소 시간 최대 길이 */
    MIN_FINISH_MINUTE_AFTER_ALLOCATED_LENGTH: 2,
    /** 라이더 관리 배차 후 완료가능 최소 시간 최대 값 */
    MIN_FINISH_MINUTE_AFTER_ALLOCATED_MAX_AMOUNT: 15,
    /** 라이더 관리 최대 배차 가능 건 수 */
    MAX_ALLOCATE_COUNT_LENGTH: 4,
    /** 라이더 관리 배달대행 수수료 그룹 대행료 시작 및 종료구간 최대 길이 */
    WORKER_FEE_GROUP_OPTION_AMOUNT_MAX_LENGTH: 9,
    /** 라이더 관리 배달대행 수수료 그룹 대행료 정률 최대 값 */
    WORKER_FEE_GROUP_OPTION_RATE_MAX_AMOUNT: 99.99,
    /** 라이더 관리 배달대행 수수료 그룹 대행료 정률 최대 길이( . 포함) */
    WORKER_FEE_GROUP_OPTION_RATE_MAX_LENGTH: 5,
    /** 배차취소 패널티 그룹 그룹명 최대 길이 */
    WORKER_PENALTY_GROUP_NAME_MAX_LENGTH: 50,
    /** 배차취소 패널티 패널티 적용 시작 건수 최대 길이 */
    WORKER_PENALTY_GROUP_OPTION_COUNT_MAX_LENGTH: 2,
    /** 상점 관리 상점 그룹별 배달대행 수수료 그룹 대행료 시작 및 종료구간 최대 길이 */
    WORKER_FEE_PER_STORE_GROUP_OPTION_AMOUNT_MAX_LENGTH: 11,
    /** 상점 관리 상점 그룹별 배달대행 수수료 그룹 수수료 최대 길이 */
    WORKER_FEE_PER_STORE_GROUP_OPTION_FEE_MAX_LENGTH: 7,
    /** 상점 관리 > 상점명 최대 byte */
    STORE_NAME_MAX_BYTE: 50,
    /** 대표자명 최대 byte */
    CEO_NAME_MAX_BYTE: 20,
    /** 상점관리 > 대표자 추가정보 > 법인등록번호 */
    CEO_RESIDENT_REGISTRATION_NUMBER_MAX_LENGTH: 13,
    /** 상점관리 > 대표자 추가정보 > 생년월일 */
    CEO_DATE_OF_BIRTH_MAX_LENGTH: 6,
    /** 상점관리 > 비용설정수정 > 기본료 최대길이 */
    DELIVERY_FEE_MONTHLY_MAX_LENGTH: 8,
    /**
     * 상점관리 > 비용설정수정 > 월 충전 건수
     *
     * 월정액인 경우(월종료갯수) 월충전인 경우(충전건수) 관련
     * (https://barogo.slack.com/archives/C04UP4VFCKA/p1691049049075859?thread_ts=1691047119.729529&cid=C04UP4VFCKA)
     */
    END_DELIVERY_COUNT_MAX_LENGTH: 5,
    /** 상점관리 > 접수운행설정 > 접수 가능 건수 */
    DAY_DELIVERY_COUNT_MAX_LENGTH: 5,
    /** 상점관리 > 접수운행설정 > 접수 제한잔액 최대 길이 */
    ORDER_LIMIT_BAROMONEY_MAX_LENGTH: 8,
    /** 사업자등록번호 최대 길이 */
    /** TODO 현재는 하이픈 처리 안되어 있음, 추후 적용 예정 */
    BUSINESS_NUMBER_MAX_LENGTH: 10,
    BUSINESS_NAME_MAX_BYTE: 50,
    /** 업태 최대 byte */
    BUSINESS_CONDITION_MAX_BYTE: 100,
    /** 종목 최대 byte */
    BUSINESS_TYPE_MAX_BYTE: 200,
    /** 상점관리 > 선차감 정액 최대 길이 */
    HUB_DELIVERY_PREPAYMENT_FEE_MAX_LENGTH: 3,
    /** 상점관리 > 선차감 정률 최대 길이 */
    HUB_DELIVERY_PREPAYMENT_FEE_RATE_MAX_LENGTH: 2,
    /** 상점관리 > 일반정보수정 > 관리자 메모 최대 byte */
    STORE_MANAGEMENT_MEMO_MAX_BYTE: 400,
    /** 상점 관리비 기본료 설정 건수 / 월 기준 관리비 범위 최대 길이 */
    STORE_MONTHLY_DELIVERY_COUNT_MAX_LENGTH: 9,
    /** 상점 관리비 기본료 설정 건수 / 월 기준 관리비 범위 최대 값 */
    STORE_MONTHLY_DELIVERY_COUNT_MAX_AMOUNT: 9999999,
    /** 상점 관리비 기본료 설정 건수 범위 최대 길이 */
    STORE_MONTHLY_DELIVERY_ADD_CHARGE_MAX_LENGTH: 5,
    /** 상점 관리비 기본료 설정 건수 범위 최대 값 */
    STORE_MONTHLY_DELIVERY_ADD_CHARGE_MAX_AMOUNT: 9999,
    /** 상점 상품가 할증 상품 요금 범위 최대 길이 */
    STORE_ORDER_AMOUNT_MAX_LENGTH: 9,
    /** 상점 상품가 할증 금액 최대 길이 */
    STORE_SURCHARGE_MAX_LENGTH: 9,
    /** 상점 상품가 할증 퍼센트 최대 길이 */
    STORE_SURCHARGE_RATE_MAX_LENGTH: 4,
    /** 상점 상품가 할증 퍼센트 최대 값 */
    STORE_SURCHARGE_RATE_MAX_AMOUNT: 99.99,
    /** 상점 상품가 할증 퍼센트 최대 값 */
    FEE_GROUP_NAME_MAX_BYTE: 100,
    /** 대표자 이메일 */
    CEO_EMAIL_MAX_BYTE: 50,
    /** 건당 관리비 (정액) 최대 길이 */
    DELIVERY_MANAGEMENT_FEE_PER_ORDER_MAX_LENGTH: 6,
    /** 건당 관리비 (정률) 최대 값 */
    DELIVERY_MANAGEMENT_FEE_RATE_PER_ORDER_MAX_AMOUNT: 99.9,
    /** 건당 상점 수수료 (정액) 최대 길이 */
    DELIVERY_FEE_PER_ORDER_MAX_LENGTH: 6,
    /** 건당 상점 수수료 (정률) 최대 값 */
    DELIVERY_FEE_RATE_PER_ORDER_MAX_AMOUNT: 99.9,
    /** 허브관리 */
    HUB_NAME_MAX_BYTE: 25,
    HUB_MASTER_ID_MAX_BYTE: 12,
    DETAIL_ADDRESS_MAX_BYTE: 80,
    WITHDRAWAL_BANK_ACCOUNT_MIN_LENGTH: 11,
    WITHDRAWAL_BANK_OWNER_MAX_BYTE: 30,
    /** 사용자 관리 */
    USER_NAME_MAX_BYTE: 12,
    USER_ID_MAX_BYTE: 12,
    USER_PW_MAX_BYTE: 20,
    USER_PHONE_MAX_LENGTH: 11,
    /** 허브관리(masterPassword)/사용자 관리 비밀번호(password) */
    PASSWORD_MIN_BYTE: 10,
    PASSWORD_MAX_BYTE: 20,
    /** 최대 공유 가능 시간 = 24시간 */
    SHARE_DELAY_SECOND_MAX_LENGTH: 86_400,
    SHARE_DELAY_SECOND_TEXT_FIELD_MAX_LENGTH: 6,
    /** 구역 설정 > 구역명 */
    DELIVERY_CHARGE_AREA_NAME_MAX_LENGTH: 50,
    /** 세금계산서 이메일 필드 글자수 제한 */
    HUB_ADJUSTMENT_TAX_INVOICE_EMAIL_FIELD: 40,
    /** 세금계산서 필드 글자수 제한 */
    HUB_ADJUSTMENT_TAX_INVOICE_FIELD: 20,
    /** 배달대행료 도착지(지명) */
    DELIVERY_CHARGE_SP_AREA_MAX_BYTE: 30,
    /** 대행료 length */
    DELIVERY_CHARGE_CHARGE_LENGTH: 6,
    /** 대행료 length (소수점 포함) */
    DELIVERY_CHARGE_DISTANCE_LENGTH: 4,
    /** 번지 length */
    DELIVERY_CHARGE_JIBUN_LENGTH: 3,
};
export default validationLimitingValue;
